import {type MediaCardType} from '@wandb/weave/common/types/media';
import {useCallback} from 'react';

import {type Panel} from '../../util/panelTypes';
import {panelViews} from '../PanelBank/types';
import {type MediaBrowserPanelConfig} from './common';
import {useGetMediaCardTypes} from './useGetMediaCardTypes';

export const SUPPORTED_MEDIA_TYPES: MediaCardType[] = [
  'image',
  'video',
  'audio',
  'object3D',
];
export const useGetIsMediaPanelSettingsDrawerSupportedForPanel = (
  panel: Panel
) => {
  const mediaKeys =
    panel.viewType === panelViews.mediaBrowser
      ? (panel.config as MediaBrowserPanelConfig).mediaKeys
      : undefined;
  const getMediaCardTypes = useGetMediaCardTypes(mediaKeys);
  return useCallback(() => {
    // hook is only meant for a single panel which is only allowed to have one media type
    const mediaType = getMediaCardTypes()?.[0];
    // Only redirect to the media panel settings drawer for supported media panels
    return (
      panel.viewType === panelViews.mediaBrowser &&
      mediaType != null &&
      SUPPORTED_MEDIA_TYPES.includes(mediaType)
    );
  }, [panel, getMediaCardTypes]);
};
